import {Component, Inject, OnInit} from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { ISnackBarAction, ISnackBarConfig } from '../../services/snack-bar.service';
import { SHARED_MODULES } from '../../../shared.';

@Component({
    selector: 'app-ph-snack-bar',
    templateUrl: './ph-snack-bar.component.html',
    styleUrls: ['./ph-snack-bar.component.scss'],
	imports: [SHARED_MODULES],
    standalone: true
})
export class PhSnackBarComponent implements OnInit {
	config: ISnackBarConfig;

	constructor(@Inject(MatSnackBarRef) private snackBarRef: any) {}

	ngOnInit(): void {
		this.config = this.snackBarRef.containerInstance.snackBarConfig.data;
	}

	dismiss(): void {
		this.snackBarRef.dismiss();
	}

	dismissWithAction(action: ISnackBarAction): void {
		action.callback();
		this.snackBarRef.dismiss();
	}
}
